import { CircularProgress, Dialog, DialogContent, Stack, Typography } from '@mui/material';
import { FC, useEffect, useState } from 'react';

interface LoadingSpinnerModalProps {
	open: boolean;
	timeoutDuration?: number;
	message?: string;
	dataTestId?: string;
}

const LoadingSpinnerModal: FC<LoadingSpinnerModalProps> = ({ open, timeoutDuration = 30000, message, dataTestId }) => {
	const [internalOpen, setInternalOpen] = useState(open);

	useEffect(() => {
		let timeout: ReturnType<typeof setTimeout> | null = null;

		if (open) {
			setInternalOpen(true);
			timeout = setTimeout(() => {
				setInternalOpen(false);
			}, timeoutDuration);
		} else {
			// match internal state to parent state
			setInternalOpen(false);
		}

		// Cleanup timeout when the component is closed/unmounted
		return () => {
			if (timeout) {
				clearTimeout(timeout);
			}
		};
	}, [open, timeoutDuration]);

	return (
		<Dialog
			open={internalOpen}
			// Prevent user from closing modal manually
			onClose={() => {
				return null;
			}}
			sx={{
				'.MuiDialog-paper': {
					width: '100%',
					maxWidth: '400px',
					borderRadius: '5px',
				},
			}}
		>
			<DialogContent>
				<Stack direction="column" alignItems="center" py={4}>
					<CircularProgress />
					<Typography data-test-id={dataTestId} mt={2} variant="header3">
						{message}
					</Typography>
				</Stack>
			</DialogContent>
		</Dialog>
	);
};

export default LoadingSpinnerModal;
